import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "VideoOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.095 6.0825C21.8523 5.96658 21.5662 5.98948 21.345 6.1425L17.25 9.045V7.83L22.5 2.58L21.42 1.5L1.5 21.42L2.58 22.5L5.58 19.5H15.75C16.5784 19.5 17.25 18.8284 17.25 18V14.955L21.315 17.8575C21.5432 18.02 21.8429 18.0417 22.0922 17.9139C22.3414 17.7862 22.4987 17.5301 22.5 17.25V6.75C22.5006 6.46923 22.3443 6.21165 22.095 6.0825ZM20.9999 15.795L16.9349 12.8925C16.7067 12.73 16.407 12.7083 16.1577 12.8361C15.9085 12.9639 15.7512 13.2199 15.7499 13.5V18H7.07989L15.7499 9.33001V10.5C15.7512 10.7801 15.9085 11.0362 16.1577 11.164C16.407 11.2918 16.7067 11.27 16.9349 11.1075L20.9999 8.20501V15.795ZM3 18V6H15V4.5H3C2.17157 4.5 1.5 5.17157 1.5 6V18H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/VideoOff.vue"]]);
